import { render, staticRenderFns } from "./OtherTraining.vue?vue&type=template&id=0ce6181a&scoped=true&"
import script from "./OtherTraining.vue?vue&type=script&lang=js&"
export * from "./OtherTraining.vue?vue&type=script&lang=js&"
import style0 from "./OtherTraining.vue?vue&type=style&index=0&id=0ce6181a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6181a",
  null
  
)

export default component.exports